import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.from("#about .about-title", {
  scrollTrigger: {
    trigger: "#about",
    start: "top bottom",
    // markers: true,
  },
  yPercent: 60,
});
gsap.from("#dont-miss .miss-title", {
  scrollTrigger: {
    trigger: "#dont-miss",
    // markers: true,
    start: "top bottom",
  },
  yPercent: 60,
});

gsap.from("#dont-miss .miss-item-number", {
  scrollTrigger: {
    trigger: "#dont-miss",
    // markers: true,
    start: "top 50%",
  },
  scale: 0,
  y: 30,
  stagger: 0.3,
});

gsap.from("#bonuses .bonuses-item", {
  scrollTrigger: {
    trigger: "#bonuses",
    // markers: true,
    start: "top 50%",
  },

  x: -30,
  opacity: 0,
  stagger: 0.3,
});

gsap.from("#discount-top .discount-circle", {
  scrollTrigger: {
    trigger: "#discount-top",
    // markers: true,
    start: "top 50%",
  },

  x: -30,
});

gsap.from("#discount-top .discount-img", {
  scrollTrigger: {
    trigger: "#discount-top",
    // markers: true,
    start: "top 50%",
  },
  y: -20,
  rotation: 10,

  yoyo: true,
  duration: 1,
  ease: "power1.inOut",
});

gsap.from("#certificate .certificate-img", {
  scrollTrigger: {
    trigger: "#certificate",
    // markers: true,
    start: "top 50%",
  },
  y: -20,
  rotation: 10,

  yoyo: true,
  duration: 1,
  ease: "power1.inOut",
});

gsap.from("#certificate .certificate-title", {
  scrollTrigger: {
    trigger: "#certificate",
    start: "top 50%",
  },
  yPercent: 60,
});

gsap.from("#certificate .certificate-text", {
  scrollTrigger: {
    trigger: "#certificate",
    start: "top 50%",
  },
  yPercent: 60,
  delay: 0.2, // затримка перед початком анімації для .certificate-text
});
gsap.from("#course-steps .steps-item-number", {
  scrollTrigger: {
    trigger: "#course-steps",
    // markers: true,
    start: "top 50%",
  },

  scale: 0,
  stagger: 0.3,
});

gsap.from("#course-steps .steps-item", {
  scrollTrigger: {
    trigger: "#course-steps",
    // markers: true,
    start: "top 50%",
  },

  x: -30,
  opacity: 0,
  stagger: 0.3,
});
